module.exports = __webpack_public_path__ + "static/media/password-thanks-img.d5701819.jpg";